<div class="container">
  <app-navigation-steps-header [active]="2"></app-navigation-steps-header>

  <h1 class="page_title">{{ 'finish_profile' | translate }}</h1>

  <span class="description">
    {{ 'add_few_details' | translate }}
  </span>

  <ui-form-container [schema]="formState" (submit)="submit($event)">
    <app-ui-input
      [size]="'large'"
      [label]="'name' | translate"
      [placeholder]="'John Doe'"
      [id]="formState.name.id"
      [disabled]="!!user?.name"
      [value]="formState.name.value"
      [validators]="[requiredValidator]"
    ></app-ui-input>

    <app-ui-input
      [size]="'large'"
      [label]="'phone_number' | translate"
      [placeholder]="'085228882401'"
      [inputType]="'number'"
      [disabled]="!!user?.phone"
      [id]="formState.phone.id"
      [value]="formState.phone.value"
      [validators]="[requiredValidator]"
    ></app-ui-input>

    <app-ui-input
      [size]="'large'"
      [label]="'company' | translate"
      [placeholder]="'pt_best_comp' | translate"
      [id]="formState.company.id"
      [disabled]="!!user?.company"
      [value]="formState.company.value"
      [validators]="[requiredValidator]"
    ></app-ui-input>

    <app-ui-select
      [size]="'large'"
      [label]="'job' | translate"
      [placeholder]="'select_role' | translate"
      [id]="formState.job.id"
      [disabled]="!!user?.role"
      [value]="formState.job.value"
      [validators]="[requiredValidator]"
      [options]="roleOptions"
    ></app-ui-select>

    <div class="grow"></div>

    <app-ui-button [fullWidth]="true" [theme]="'primary'" [size]="'medium'" uiFormContainerButton>
      {{ 'get_started' | translate }}
    </app-ui-button>
  </ui-form-container>
</div>
